module.exports = __webpack_public_path__ + "static/media/See Me Fly.843a1fc4.jpg";